import { FiRefreshCw } from 'react-icons/fi';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useMsal } from '@azure/msal-react';
import { Button, IconButton, Tooltip } from '@mui/material';

import { msalConfig } from '../../../config';
import { images } from '../../../constant';
import { usePayLinkCart } from '../context/PayLinkCartContext';

const PAYLINK_LOCAL_STORAGE_KEYS = [
  "paylink_cart_items",
  "paylink_store_profile",
  "paylink_c_s",
  "paylink_entry_path",
  "C_S",
  "P_D",
  "session_data",
  "loginFlow",
  "mode",
  "redirectUrl",
];

export const Nav = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const { storeProfile } = usePayLinkCart();

  const handleResetSession = () => {
    const entryPath = localStorage.getItem("paylink_entry_path") ?? "";
    const isStorePath = /^\/paylink\/s\/[^/]+(\/p\/[^/]+)?$/.test(entryPath);
    const fallbackStorePath = storeProfile?.slug
      ? `/paylink/s/${storeProfile.slug}`
      : "/paylink";
    const targetStorePath = isStorePath ? entryPath : fallbackStorePath;
    const isAfterCheckoutSuccess = location.pathname === "/paylink/order-confirmed";

    const confirmed = window.confirm(
      "Start over? This will clear your current cart and return you to the store."
      // isAfterCheckoutSuccess
      //   ? "Start over? This will clear your current cart and return you to the store."
      //   : "Start over? This will clear your current cart, saved details, and sign you out.",
    );
    if (!confirmed) return;

     navigate(targetStorePath, { replace: true });
     return;

    // Clear all known paylink-related local storage keys
    // PAYLINK_LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));

    // // Clear merchant-scoped session entry (keyed by customer URN)
    // if (storeProfile?.customerUniqueReferenceNumber) {
    //   localStorage.removeItem(storeProfile.customerUniqueReferenceNumber);
    // }

    // // After a successful checkout, return to the original store paylink route instead of logging out.
    // if (isAfterCheckoutSuccess) {
    //   navigate(targetStorePath, { replace: true });
    //   return;
    // }

    // // Sign the user out of MSAL if signed in; otherwise just reload the page
    // const account = accounts?.[0];
    // if (account) {
    //   instance.logoutRedirect({
    //     account,
    //     postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
    //   });
    //   return;
    // }

    // navigate(0);
  };

  return (
    <nav className="!py-[0.875rem] !px-5 lg:px-0 border-b border-py_black-100 bg-white">
      <div className="!container flex items-center justify-between">
        <Link to="#" className="inline-flex flex-col">
          <img
            src={images.PaycurraLogo}
            alt="Paycurra logo"
            width={74}
            height={24}
          />
          <small className="text-[0.5rem] text-py_black-950 font-medium leading-[120%] tracking-[-0.02em] ml-auto -mt-1">
            Checkout
          </small>
        </Link>

        <div className="flex items-center gap-1">
          <Tooltip title="Start over (clear session)">
            <IconButton
              size="small"
              onClick={handleResetSession}
              aria-label="Start over"
              className="!text-py_black-950"
            >
              <FiRefreshCw size={16} />
            </IconButton>
          </Tooltip>

          <Button className="!rounded-md !p-1 !text-[0.625rem] !text-py_black-950 !font-medium !capitalize">
            Contact Support
          </Button>
        </div>
      </div>
    </nav>
  );
};
